
import { useSymbolValidation } from './useSymbolValidation';
import { useMarketDataFetch } from './useMarketDataFetch';
import { useCorrelation } from './useCorrelation';
import { UseRealMarketDataResult } from './types';
import { useEffect } from 'react';
import { updateOnlineModel } from '@/services/onlineLearner';

export const useRealMarketData = (): UseRealMarketDataResult => {
  const {
    symbolStatus,
    validateSymbol,
    apiCallCount,
    setApiCallCount,
    isDevMode
  } = useSymbolValidation();

  const {
    marketData,
    setMarketData,
    fetchMarketData,
    isLoading,
    error
  } = useMarketDataFetch(apiCallCount, setApiCallCount, isDevMode);

  const { getCorrelation } = useCorrelation(
    marketData,
    setMarketData,
    apiCallCount,
    setApiCallCount,
    isDevMode
  );

  // On each marketData change, send new features to online learner
  useEffect(() => {
    Object.entries(marketData).forEach(([symbol, data]) => {
      if (data && 'features' in data && Array.isArray((data as any).features)) {
        const feats = (data as any).features;
        if (feats.length > 0) {
          const lastFeat = feats[feats.length - 1];
          updateOnlineModel(symbol, lastFeat);
        }
      }
    });
  }, [marketData]);
  return {
    marketData,
    symbolStatus,
    validateSymbol,
    fetchMarketData,
    getCorrelation,
    isLoading,
    error
  };
};
